import script from "./AppVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVersion.vue?vue&type=script&setup=true&lang=js"

import "./AppVersion.vue?vue&type=style&index=0&id=97df20c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97df20c6"]])

export default __exports__